import React from 'react';
import {Trusted_slider} from './Trusted_By';
import TittleWithAnimation from './TittleWithAnimation'
import { Link } from "react-router-dom";

const featured_logos_4 = [
    'https://www.logodesign.net/logo/line-art-house-roof-and-buildings-4485ld.png',
    'https://inkbotdesign.com/wp-content/uploads/2012/09/NBC-Logo-Design.png?ezimgfmt=rs:352x211/rscb15/ng:webp/ngcb15',
    'https://images.squarespace-cdn.com/content/v1/5ede2122e582b96630a4a73e/1609375996518-DZU53FYNB3FMBYB1JHG6/HP-logo+2021.jpg',
    'https://brandongaille.com/wp-content/uploads/2014/04/Motorola-Company-Logo.jpg',
    'https://1757140519.rsc.cdn77.org/blog/wp-content/uploads/2018/04/NASA-logo-history.png'
]

const featured_logos_3 = [
    'https://www.comunicaffe.com/wp-content/uploads/2016/06/Olam-International-Logo-e1467633439339.jpg',
    'https://1000logos.net/wp-content/uploads/2020/06/TVS-Motor-Logo.png',
    'https://brandongaille.com/wp-content/uploads/2013/12/Nokia-Company-Logo.jpg',
    'https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Procter_%26_Gamble_logo.svg/1200px-Procter_%26_Gamble_logo.svg.png',
    'https://seeklogo.com/images/B/business-company-logo-4A111D4E18-seeklogo.com.png'
]
const featured_logos_2 = [
    'https://99designs-blog.imgix.net/blog/wp-content/uploads/2017/01/amazon-current.png?auto=format&q=60&fit=max&w=930',
    'https://brandongaille.com/wp-content/uploads/2014/04/Kimberly-Clark-Company-Logo.jpg',
    'https://ifranchise.ph/wp-content/uploads/2019/07/BDO-201302261-600x338.png',
    'https://cdn2.hubspot.net/hub/145335/file-407358136-png/blog-files/ebay.png'
]
const featured_logos_1 = [
    'https://cdn2.hubspot.net/hub/145335/file-407358456-png/blog-files/disney.png',
    'https://srbs.edu.in/wp-content/uploads/2021/09/27.-vivo.png',
    'https://upload.wikimedia.org/wikipedia/commons/e/e8/Tesla_logo.png',
    'https://cdn.logojoy.com/wp-content/uploads/2018/05/30162655/6_big7-768x591.png'
]

const Featured_on = () => {
    return (
        <section id="featured-on">
            <div className="container">
                <div className="col-lg-6">
                    <div className="large-tittle">
                        <h1>Featured On</h1>
                    </div>

                    <div className="short-text-line mt-5">
                        <TittleWithAnimation
                                word="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Odit molestias officia adipisci deserunt error vero quia similique eos culpa, corrupti explicabo magni ipsam voluptatem blanditiis tempora vitae maiores, quod voluptatibus." 
                                _trigger="#featured-on .short-text-line"
                        />
                    </div>

                    <div className="find-cta-btn">
                         <Link to="/search-carrier" className="home-btns">
                            <i className="fa-solid fa-dolly"></i>
                            Find Dispatcher
                        </Link>
                        
                        <Link to="/search-carrier" className="home-btns">
                            <i className="fa-solid fa-truck-moving"></i>
                            Find Career
                        </Link>
                    </div>
                </div>
            </div>

            <div className="trusted-by-groups featured-on-img-group">
                <Trusted_slider company_logo={featured_logos_1}/>
                <Trusted_slider company_logo={featured_logos_2}/>
                <Trusted_slider company_logo={featured_logos_3}/>
                <Trusted_slider company_logo={featured_logos_4}/>
            </div>
        </section>
    )
}

export default Featured_on;